<template>
  <div class="igs-home" :class="{'fix-search': miniSearch}">
    <!-- 头部 -->
    <div class="home-head">
      <div class="bg"></div>
      <i class="logo"></i>
      <p class="name">中华人民共和国中央人民政府</p>
      <div class="search-bar" ref="stickyHead">
        <cube-input @focus="handleFocus" class="search-input" :clearable="true"></cube-input>
        <input-tip v-show="!showSearchInput" :show-tip="!showSearchInput" class="home-tip"></input-tip>
      </div>
    </div>

    <search-input ref="searchInput" v-show="showSearchInput" :first-hot="firstHot" :hot-words="hotwords" @back="goBack" @search="handleSearch" />

    <!-- 热搜词 -->
    <div class="hot-words section">
      <div class="section-title">热搜词</div>
      <div class="hot-words-wrap clearfix">
        <div v-for="(word, index) in hotwords" :key="index" class="hot-word-item fl" @click.prevent="handleSearch({searchWord: word})">{{ word }}</div>
      </div>
    </div>

    <!-- 推荐内容 -->
    <div class="recommend-list section">
      <div class="section-title">推荐内容</div>
      <ul>
        <li v-for="(item, index) in recommends" :key="index" class="recommend-item" :class="{'recommend-img-item': item.imgUrl && item.imgUrl}">
          <a :href="item.url">
            <img v-if="item.imgUrl" :src="JSON.parse(item.imgUrl)[0].url" alt="" />
            <div class="recommend-msg">
              <div class="title" v-html="$options.filters.spaceFilter(item.title)"></div>
              <div class="meta-wrap">
                <span class="source overflow">{{ item.source }}</span>
                <span class="date overflow">{{ timeago(item.time) }}</span>
              </div>
            </div>
          </a>
        </li>
        <li v-if="recommends.length === 0 && pager.total === 0" class="no-data">暂无数据</li>
      </ul>
    </div>

    <div v-if="+pager.pageNo < +pager.pageCount" class="pullup-wrap">
      <cube-loading></cube-loading>
      数据加载中...
    </div>
  </div>
</template>

<script>
import {listenScroll, resetSign, timeago} from '@/utils'
import SearchInput from '../search-input/search-input'
import InputTip from '../search-input/input-tip.vue'
import {backToApp} from '@/utils'

export default {
  name: 'home',

  components: {
    SearchInput,
    InputTip
  },

  filters: {
    spaceFilter(value) {
      if (!value) return ''

      return value.replace(/\s/g, '')
    }
  },

  data() {
    return {
      firstHot: '',
      hotwords: [],
      pager: {
        pageNo: 0,
        pageCount: 1
      },

      showSearchInput: window.sessionStorage.getItem('igs-is-embed') === 'true' || false, // 是否显示输入框二级页
      recommends: [],
      firstCategory: '',

      miniSearch: false,
      isDown: false,
      loading: false
    }
  },

  mounted() {
    this.initData()

    window.addEventListener('scroll', this.handleScroll)
  },

  watch: {
    isDown(newVal, oldVal) {
      if (newVal && +this.pager.pageNo < +this.pager.pageCount) {
        this.queryRecommend().then(data => {
          this.recommends = this.recommends.concat(data)
        })
      }
    }
  },

  methods: {
    timeago,
    initData() {
      this.recommends = []
      this.queryHotwords()
      this.queryCategory()

      this.queryRecommend().then(data => {
        this.recommends = this.recommends.concat(data)
      })
    },

    queryHotwords() {
      let params = {
        code: this.$route.query.code,
        configCode: this.$route.query.configCode
      }
      this.axios.get('/front/app/index/hot-words', {params}).then(data => {
        this.hotwords = data
      })
    },

    /**
     * 获取分类
     */
    queryCategory() {
      let params = {
        code: this.$route.query.code,
        configCode: this.$route.query.configCode
      }
      this.axios.get('/front/data-types', {params}).then(data => {
        this.firstCategory = data[0] ? data[0].id : ''
      })
    },

    queryRecommend() {
      return new Promise(resolve => {
        this.pager.pageNo = this.pager.pageNo + 1
        let params = {
          code: this.$route.query.code,
          configCode: this.$route.query.configCode,
          pageNo: this.pager.pageNo,
          pageSize: 10
        }
        this.axios.get('/front/app/index/recommend', {params}).then(data => {
          this.pager = Object.assign(this.pager, data.pager)
          resolve(data.data)
        })
      })
    },

    handleScroll() {
      this.miniSearch = window.scrollY > 630

      listenScroll(() => {
        // 滚动到底部
        if (window.pageYOffset + window.innerHeight >= document.documentElement.scrollHeight) {
          this.isDown = true
        } else {
          this.isDown = false
        }
      })()
    },

    handleSearch(data) {
      resetSign()
      const query = {
        searchWord: data.searchWord,
        code: this.$route.query.code,
        configCode: this.$route.query.configCode,
        codes: this.$route.query.codes,
        dataTypeId: this.firstCategory
      }
      this.$router.push({path: '/search-result', query: query})
    },

    handleFocus() {
      this.showSearchInput = true
      this.$nextTick(() => {
        this.$refs.searchInput.$refs.input.focus()
      })
    },

    goBack() {
      if (!backToApp()) {
        this.showSearchInput = false
        this.$refs.searchInput.isFocus = true
      }
    }
  }
}
</script>

<style lang="scss">
.igs-home {
  background-color: #ffffff;

  .home-head {
    position: relative;
    height: 210px;
    min-height: 80px;
    margin-bottom: 48px;
    padding-top: 77px;
    text-align: center;
    background-color: $theme-color;

    .bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('./images/home-bg.png') no-repeat center / cover;
      opacity: 0.15;
    }

    .logo {
      display: block;
      width: 60px;
      height: 60px;
      margin: 0 auto;
      background: url('./images/home-logo.png') no-repeat center / cover;
    }

    .name {
      margin: 8px 0 17px 0;
      font-size: 24px;
      color: #ffffff;
    }

    .search-bar {
      position: relative;

      .home-tip.input-tips-box {
        left: 28px;
        right: 30px;
        top: 12px;
        z-index: 1;
      }
    }

    .cube-input {
      margin: 0 16px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
      border-radius: 8px;

      &::after {
        display: none;
      }
    }

    .cube-input input {
      height: 48px;
      line-height: 48px;
      border-radius: 8px;
      z-index: 10;
      background-color: transparent;
    }
  }

  .section {
    padding: 16px;
    background-color: #ffffff;
  }
  .section + .section {
    border-top: 8px solid #f5f5f5;
  }

  .section-title {
    font-size: 18px;
    font-weight: 700;
  }

  .hot-words {
    padding-top: 0;
    .hot-words-wrap {
      margin-top: 9px;
    }

    .hot-word-item {
      height: 32px;
      line-height: 32px;
      margin-top: 12px;
      margin-right: 12px;
      padding: 0 12px;
      background: $grey-color;
      border-radius: 4px;
      font-size: 15px;
    }
  }

  .pullup-wrapper {
    height: 100%;
    overflow: hidden;

    .pullup-txt {
      font-size: 12px;
      color: #999999;
      text-align: center;
    }
  }

  // 推荐内容
  .recommend-list {
    height: 100%;

    .recommend-item {
      padding-top: 12px;

      .title {
        display: -webkit-box;
        font-size: 16px;
        line-height: 22px;
        overflow: hidden;
        white-space: initial;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      img {
        float: right;
        width: 108px;
        height: 72px;
        object-fit: cover;
        border-radius: 4px;
      }

      .meta-wrap {
        height: 42px;
        line-height: 42px;
        font-size: 12px;
        span {
          display: inline-block;
        }
        .source {
          padding-right: 8px;
          color: #999;
        }
        .date {
          color: #999;
        }
      }
    }
    .recommend-item + .recommend-item {
      border-top: 1px solid #f8f8f8;
    }

    .no-data {
      height: 100px;
      line-height: 100px;
      text-align: center;
      color: #999999;
    }

    .recommend-img-item {
      .recommend-msg {
        width: calc(100% - 108px);
        min-height: 86px;
        padding-right: 12px;
      }
    }
  }

  .loading-wrap {
    height: 48px;
    line-height: 48px;
    text-align: center;
  }
}

.fix-search {
  .search-bar {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    .search-input {
      padding: 16px;
      margin: 0;
      box-shadow: none;
    }

    .search-input input {
      height: 46px;
      line-height: 46px;
      border: 1px solid #333;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
      border-radius: 8px;
    }
  }
}
</style>
